<template>
  <div>
    <el-header>
      <div class="myHeader">
        <el-card shadow="hover">
          <el-row style="display: flex">
            <el-col :span="14" style="display: flex; align-items: center">
              <el-button class="myLogo" @click="toHome"></el-button>
              <h1 style="margin-left: 10px" class="myLogoText">DAWN's BLOG</h1>
            </el-col>
            <el-col :span="3">
              <div class="headButton" @click="toMy2023" style="font-weight:bolder;">
                2024总结
                <svg style="margin-left: 10px;" t="1703120520774" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="12490" width="32" height="32">
                  <path d="M596.8 457.7m-334.4 0a334.4 334.4 0 1 0 668.8 0 334.4 334.4 0 1 0-668.8 0Z" fill="#FFE4CC"
                    p-id="12491"></path>
                  <path d="M111.9 795.5V127.3c0-27.3 22.1-49.4 49.4-49.4h143.6c27.3 0 49.4 22.1 49.4 49.4v668.2H111.9z"
                    fill="#FFFFFF" p-id="12492"></path>
                  <path
                    d="M354.3 808.5H111.9c-7.2 0-13-5.8-13-13V127.3C99 93 126.9 65 161.3 65h143.6c34.4 0 62.3 28 62.3 62.3v668.2c0.1 7.2-5.7 13-12.9 13z m-229.4-25.9h216.4V127.3c0-20.1-16.3-36.4-36.4-36.4H161.3c-20.1 0-36.4 16.3-36.4 36.4v655.3z"
                    fill="#441B00" p-id="12493"></path>
                  <path d="M205.4 933.8L112 793.4h242.3l-93.4 140.4c-14.6 17.1-41 17.1-55.5 0z" fill="#F88E20"
                    p-id="12494"></path>
                  <path
                    d="M233.1 959.6c-14.5 0-28.2-6.3-37.7-17.4l-0.9-1.2-93.4-140.4c-2.7-4-2.9-9.1-0.6-13.3 2.3-4.2 6.7-6.9 11.4-6.9h242.3c4.8 0 9.2 2.6 11.4 6.9 2.3 4.2 2 9.3-0.6 13.3L271.7 941l-0.9 1.2c-9.4 11.1-23.2 17.4-37.7 17.4z m-17.4-33.7c4.4 4.9 10.8 7.8 17.4 7.8s13-2.8 17.4-7.8L330 806.3H136.2l79.5 119.6z"
                    fill="#441B00" p-id="12495"></path>
                  <path d="M292.9 885.6H173.3" fill="#FFFFFF" p-id="12496"></path>
                  <path d="M292.9 898.6H173.3c-7.2 0-13-5.8-13-13s5.8-13 13-13H293c7.2 0 13 5.8 13 13s-5.9 13-13.1 13z"
                    fill="#441B00" p-id="12497"></path>
                  <path d="M268.9 792.2V310.9" fill="#FFFFFF" p-id="12498"></path>
                  <path
                    d="M268.9 805.1c-7.2 0-13-5.8-13-13V310.9c0-7.2 5.8-13 13-13s13 5.8 13 13v481.3c0 7.1-5.8 12.9-13 12.9z"
                    fill="#441B00" p-id="12499"></path>
                  <path
                    d="M761.7 946.7H476.1c-17.6 0-31.8-14.2-31.8-31.8V104.6c0-17.6 14.2-31.8 31.8-31.8h285.6c17.6 0 31.8 14.2 31.8 31.8v810.2c0 17.6-14.2 31.9-31.8 31.9z"
                    fill="#FFFFFF" p-id="12500"></path>
                  <path
                    d="M761.7 959.6H476.1c-24.7 0-44.8-20.1-44.8-44.8V104.6c0-24.7 20.1-44.8 44.8-44.8h285.6c24.7 0 44.8 20.1 44.8 44.8v810.2c0 24.8-20.1 44.8-44.8 44.8zM476.1 85.8c-10.4 0-18.8 8.4-18.8 18.8v810.2c0 10.4 8.4 18.8 18.8 18.8h285.6c10.4 0 18.8-8.4 18.8-18.8V104.6c0-10.4-8.4-18.8-18.8-18.8H476.1z"
                    fill="#441B00" p-id="12501"></path>
                  <path d="M697.1 70.2h96.5v876.5h-96.5z" fill="#F88E20" p-id="12502"></path>
                  <path d="M450.8 163.7h148.7" fill="#FFFFFF" p-id="12503"></path>
                  <path
                    d="M599.5 176.7H450.8c-7.2 0-13-5.8-13-13s5.8-13 13-13h148.6c7.2 0 13 5.8 13 13s-5.8 13-12.9 13z"
                    fill="#441B00" p-id="12504"></path>
                  <path d="M450.8 280.6H536" fill="#FFFFFF" p-id="12505"></path>
                  <path d="M536 293.5h-85.2c-7.2 0-13-5.8-13-13s5.8-13 13-13H536c7.2 0 13 5.8 13 13s-5.8 13-13 13z"
                    fill="#441B00" p-id="12506"></path>
                  <path d="M450.8 511.6H536" fill="#FFFFFF" p-id="12507"></path>
                  <path d="M536 524.6h-85.2c-7.2 0-13-5.8-13-13s5.8-13 13-13H536c7.2 0 13 5.8 13 13s-5.8 13-13 13z"
                    fill="#441B00" p-id="12508"></path>
                  <path d="M450.8 743.5H536" fill="#FFFFFF" p-id="12509"></path>
                  <path d="M536 756.5h-85.2c-7.2 0-13-5.8-13-13s5.8-13 13-13H536c7.2 0 13 5.8 13 13s-5.8 13-13 13z"
                    fill="#441B00" p-id="12510"></path>
                  <path d="M450.8 859.4h148.7" fill="#FFFFFF" p-id="12511"></path>
                  <path
                    d="M599.5 872.4H450.8c-7.2 0-13-5.8-13-13s5.8-13 13-13h148.6c7.2 0 13 5.8 13 13s-5.8 13-12.9 13z"
                    fill="#441B00" p-id="12512"></path>
                  <path d="M450.8 627.5h148.7" fill="#FFFFFF" p-id="12513"></path>
                  <path
                    d="M599.5 640.5H450.8c-7.2 0-13-5.8-13-13s5.8-13 13-13h148.6c7.2 0 13 5.8 13 13s-5.8 13-12.9 13z"
                    fill="#441B00" p-id="12514"></path>
                  <path d="M450.8 395.6h148.7" fill="#FFFFFF" p-id="12515"></path>
                  <path
                    d="M599.5 408.6H450.8c-7.2 0-13-5.8-13-13s5.8-13 13-13h148.6c7.2 0 13 5.8 13 13s-5.8 13-12.9 13z"
                    fill="#441B00" p-id="12516"></path>
                  <path
                    d="M761.7 959.6H476.1c-24.7 0-44.8-20.1-44.8-44.8V104.6c0-24.7 20.1-44.8 44.8-44.8h285.6c24.7 0 44.8 20.1 44.8 44.8v810.2c0 24.8-20.1 44.8-44.8 44.8zM476.1 85.8c-10.4 0-18.8 8.4-18.8 18.8v810.2c0 10.4 8.4 18.8 18.8 18.8h285.6c10.4 0 18.8-8.4 18.8-18.8V104.6c0-10.4-8.4-18.8-18.8-18.8H476.1z"
                    fill="#441B00" p-id="12517"></path>
                </svg>
              </div>
            </el-col>
            <!-- 主页按钮 -->
            <el-col :span="2">
              <div class="headButton" @click="toHome">
                主页
                <svg style="margin-left: 10px" t="1702215107644" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="965" width="32" height="32">
                  <path
                    d="M957.9 391.5c-1.1-7.5-5.5-14.2-12-18.5L527.4 98.9c-4.6-3.1-10.1-4.7-15.7-4.7-5.7 0-11.1 1.6-15.7 4.7L77.4 373.1c-6.2 4.1-10.4 10.3-11.6 17.4-1.2 7 0.5 14 4.8 19.7 5.2 6.9 13.7 11.1 22.6 11.1 5.6 0 11.1-1.6 15.7-4.7l40.2-26.3v435.4c0 57.8 45.8 104.7 102.2 104.7h520.8c56.3 0 102.2-47 102.2-104.7V390.2l40.4 26.5c5.7 3.5 11.1 5.2 16.4 5.2 7.9 0 15.2-3.8 21.5-11.4 4.4-5.4 6.3-12.1 5.3-19zM616.3 884.4H407V631.7c0-54 46.9-97.9 104.6-97.9 57.7 0 104.6 43.9 104.6 97.9v252.7z m202.4-58.8c0 28.6-20.9 51.9-46.6 51.9H665V631.7c0-79.4-68.8-143.9-153.3-143.9-84.5 0-153.3 64.6-153.3 143.9v245.9H251.3c-25.7 0-46.7-23.3-46.7-51.9V353.9l307.1-201.2 307.1 201.2v471.7z"
                    fill="#6B400D" p-id="966"></path>
                  <path d="M511.7 533.8c-57.7 0-104.6 43.9-104.6 97.9v252.7h209.3V631.7c-0.1-54-47-97.9-104.7-97.9z"
                    fill="#FFD524" p-id="967"></path>
                  <path
                    d="M270.3 504.3c-17.5 0-31.7 14.7-31.7 32.8 0 18.1 14.2 32.8 31.7 32.8s31.7-14.7 31.7-32.8c-0.1-18.1-14.3-32.8-31.7-32.8zM270.3 592.9h-1.4c-13.1 0-23.8 10.7-23.8 23.8v212.5c0 13.1 10.7 23.8 23.8 23.8h1.4c13.1 0 23.8-10.7 23.8-23.8V616.7c0-13.1-10.7-23.8-23.8-23.8z"
                    fill="#6B400D" p-id="968"></path>
                </svg>
              </div>
            </el-col>

            <el-col :span="2">
              <div class="headButton" @click="toDaily">
                随笔
                <svg style="margin-left: 10px" t="1702215206154" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="1115" width="32" height="32">
                  <path
                    d="M864 80v864a48 48 0 0 1-48 48h-672A48 48 0 0 1 96 944V928h704V96H96v-16A48 48 0 0 1 144 32h672A48 48 0 0 1 864 80z"
                    fill="#2C9C2C" p-id="1116"></path>
                  <path
                    d="M160 224H96V160h64v64z m0 64H96v64h64V288z m0 128H96v64h64v-64z m0 128H96v64h64v-64z m0 128H96v64h64v-64z m-64 128v64h64v-64H96z"
                    fill="#DDDDDD" p-id="1117"></path>
                  <path
                    d="M96 224H32V160h64v64z m192 0V160H160v64h128zM96 288H32v64h64V288z m64 64h128V288H160v64z m-64 64H32v64h64v-64z m64 64h128v-64H160v64z m-64 64H32v64h64v-64z m64 64h128v-64H160v64z m-64 64H32v64h64v-64z m64 64h128v-64H160v64z m-64 64H32v64h64v-64z m192 0H160v64h128v-64z"
                    fill="#999999" p-id="1118"></path>
                  <path
                    d="M96 160V96h64v64H96z m64 64H96v64h64V224z m0 128H96v64h64v-64z m0 128H96v64h64v-64z m0 128H96v64h64v-64z m0 128H96v64h64v-64z m0 128H96v64h64v-64z"
                    fill="#BBCBCB" p-id="1119"></path>
                  <path
                    d="M736 224H352V160h384v64z m0 64H352v64h384V288z m0 128H352v64h384v-64z m0 128H352v64h384v-64z m0 128H352v64h384v-64z m0 128H352.032v64H736v-64z"
                    fill="#DBE3F5" p-id="1120"></path>
                  <path
                    d="M811.84 645.6l104.384 104.192c-1.152 0.672-2.912 1.344-4.128 2.528-51.776 51.264-103.616 102.4-155.136 153.92-6.72 6.72-13.952 11.008-23.04 13.6-35.328 10.016-70.528 20.576-105.76 30.88-7.84 2.304-14.016 0.224-18.016-5.888a15.104 15.104 0 0 1-1.312-12.768c11.264-38.56 22.496-77.12 33.984-115.552a18.016 18.016 0 0 1 4.672-7.648c53.728-53.28 107.488-106.432 161.248-159.584 1.184-1.216 2.176-2.56 3.104-3.68z m-143.616 187.456c-0.576 1.632-0.96 2.784-1.312 3.968-4.736 16.16-8.928 32.48-14.464 48.352-2.88 8.288-2.08 14.08 5.12 19.008a14.304 14.304 0 0 1 3.456 3.488c1.6 2.016 3.328 2.08 5.696 1.408 13.184-4 26.432-7.872 39.648-11.744 6.624-1.984 13.248-3.872 20.352-5.984-1.12-1.248-1.76-2.24-2.592-2.88a16.736 16.736 0 0 1-7.36-15.872c0.192-2.528-0.128-5.088-0.32-7.616-0.416-7.04-0.8-14.048-1.312-21.248-9.696-0.768-18.88-1.76-28.064-2.208-6.72-0.384-13.088-1.024-17.216-7.328-0.256-0.384-0.736-0.608-1.632-1.344z m298.88-141.824l-98.816-98.688c7.968-7.264 14.4-16.736 24.864-21.792 12.64-6.08 28.32-3.232 39.52 7.808 16.256 16 32.448 32.064 48.384 48.416 14.72 15.104 14.464 35.488-0.192 50.592-4.576 4.704-9.344 9.248-13.76 13.664z m-13.408 19.424l-22.56 21.088-103.168-103.2 22.528-21.12 103.2 103.232z m0 0"
                    fill="#00A0E8" p-id="1121"></path>
                </svg>
              </div>
            </el-col>
            <el-col :span="2">
              <div class="headButton" @click="toWeb">
                摄影
                <svg style="margin-left: 8px" t="1728366432490" class="icon" viewBox="0 0 1690 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10618" width="50" height="50"><path d="M1479.465475 214.49494l-896.863973-0.939343-0.834972 786.856453 896.863974 1.043714a117.313523 117.313523 0 0 0 117.417895-117.209152l0.834971-552.229406a117.417895 117.417895 0 0 0-117.417895-117.522266z" fill="#92CAEE" p-id="10619"></path><path d="M1478.734875 921.298481l-896.863974-1.043714v80.157283l896.863974 1.043714a117.313523 117.313523 0 0 0 117.417895-117.209152V803.671843a117.313523 117.313523 0 0 1-117.417895 117.626638z" fill="#5DA1D3" p-id="10620"></path><path d="M581.735218 1000.474672l0.960218-786.960824 90.385686 0.104372-0.960217 786.960824z" fill="#5DA1D3" p-id="10621"></path><path d="M1309.131249 604.739837a259.15434 259.15434 0 1 1-258.841226-259.363084 259.049969 259.049969 0 0 1 258.841226 259.363084z" fill="#ECEBEB" p-id="10622"></path><path d="M1287.943842 604.739837c-3.653001 129.629356-105.937034 237.758191-238.175676 237.653819a237.966934 237.966934 0 0 1 0-475.933867c132.343014 0 234.313932 108.441949 237.653819 238.280048 0.7306 27.13658 43.001042 27.240952 42.374814 0-3.026772-115.539209-70.555108-219.18007-179.832029-261.867999a282.429176 282.429176 0 0 0-316.245531 82.870941c-161.671395 196.635835 12.83769 496.912531 263.642314 454.850832 135.682901-22.752979 229.617217-141.31896 232.957103-275.853774 0.7306-27.240952-41.644213-27.240952-42.374814 0z" fill="#49494A" p-id="10623"></path><path d="M1234.192539 604.635465a184.215631 184.215631 0 1 1-184.006887-184.320002 184.215631 184.215631 0 0 1 184.006887 184.320002z" fill="#F3D24F" p-id="10624"></path><path d="M1213.005133 604.635465c-3.54863 88.820114-72.12068 162.819481-163.236967 162.71511a162.923852 162.923852 0 1 1 0-325.847705c91.116286 0 159.479594 74.312481 162.819481 163.132595 1.043715 27.13658 43.314157 27.240952 41.748585 0-4.174858-111.990579-90.072572-204.985552-205.089923-205.507409a205.298666 205.298666 0 0 0 0 410.597332c114.808608 0 201.123807-93.934316 205.507408-205.089923 1.669943-27.240952-40.70487-27.240952-41.748584 0z" fill="#49494A" p-id="10625"></path><path d="M1516.93483 340.993152a39.765527 39.765527 0 1 1-39.661155-39.765527 39.661156 39.661156 0 0 1 39.661155 39.765527z" fill="#F3D24F" p-id="10626"></path><path d="M1495.851795 340.993152c-1.356829 23.901065-37.364983 24.005436-37.260612 0s36.008154-23.796693 37.260612 0c1.356829 27.13658 43.731643 27.345323 42.270442 0a60.952934 60.952934 0 1 0-63.144734 60.848562 61.996648 61.996648 0 0 0 63.144734-60.848562c1.565572-27.13658-40.809242-27.13658-42.270442 0z" fill="#49494A" p-id="10627"></path><path d="M837.789726 23.18205c-41.122356 21.918007-54.377532 71.911937-67.84145 115.852323l561.205352 0.626229c-13.359547-43.940386-28.493409-92.78623-67.632708-116.061066z" fill="#5DA1D3" p-id="10628"></path><path d="M827.143837 4.917044c-46.549672 29.745867-62.622877 77.861111-77.547996 128.48127a20.874292 20.874292 0 0 0 20.874292 26.719094l561.205352 0.7306a21.39615 21.39615 0 0 0 20.874292-26.823465C1336.580944 85.491813 1315.080423 9.822503 1255.693061 2.412129c-43.209785-5.427316-90.594429 0-134.117329 0L837.789726 1.994643c-27.240952 0-27.240952 42.270442 0 42.270442h384.086981c10.437146 0 27.032209-3.339887 36.634383 0 28.910895 10.437146 43.5229 72.225052 52.185731 100.509718l20.874293-26.823466-561.205352-0.626228 20.874292 26.719094c11.689604-38.51307 21.918007-79.94854 58.134905-103.119005 22.022379-14.194519 0.7306-50.828902-22.231122-36.008154zM1479.465475 193.307533l-784.769023-0.834972H582.601502a21.500521 21.500521 0 0 0-20.874293 20.874293l-0.939343 786.856453a21.500521 21.500521 0 0 0 20.874292 20.874292l758.676158 0.939343c98.944146 0 241.933049 22.022379 272.931374-105.728291 9.602175-39.765527 3.861744-86.523942 3.966115-126.706955V556.102735c0-69.720137 0.939343-139.440273 0-208.742924-0.834972-84.22777-50.724531-148.938076-138.396558-154.156649-27.240952-1.565572-27.13658 40.809242 0 42.374813 85.584599 5.00983 96.021745 74.625595 96.021745 141.110217V566.748624c0 105.206434 5.636059 212.395925 0 317.393617-7.410374 127.333184-180.040772 96.021745-266.773457 95.917373L876.720282 979.642129H581.870901l20.874293 20.874292 0.834971-786.856453-20.874292 20.874293 784.873395 0.939343h111.990579c27.13658 0.208743 27.13658-42.061699-0.104372-42.166071zM1668.795308 784.258752c27.240952 0 27.240952-42.374814 0-42.374814s-27.240952 42.374814 0 42.374814zM1647.921015 490.557457v200.393207c0 27.240952 41.748585 27.345323 41.748585 0L1690.817686 490.557457c0-27.240952-42.374814-27.345323-42.374813 0z" fill="#49494A" p-id="10629"></path><path d="M1483.744705 160.95238c71.39008 2.713658 136.517872 46.445301 157.287794 116.896037 10.437146 36.112526 7.097259 75.66931 6.992888 112.825551 0 27.240952 42.374814 27.345323 42.374813 0 0-57.299933 2.818029-113.347408-25.988494-165.533139a211.560954 211.560954 0 0 0-180.667001-106.458891c-27.240952-1.043715-27.240952 41.748585 0 42.270442zM1537.809123 678.426089v-87.463285c0-27.240952-42.270442-27.240952-42.270442 0V678.426089c0 27.240952 42.270442 27.240952 42.374813 0zM1537.60038 798.766385v-56.986819c0-27.240952-42.270442-27.345323-42.374814 0v56.986819c0 27.240952 41.748585 27.240952 41.748585 0zM1516.412973 885.185955c27.240952 0 27.240952-42.374814 0-42.374813s-27.345323 42.374814 0 42.374813z" fill="#49494A" p-id="10630"></path><path d="M494.198873 242.570863c-9.602175-39.765527-26.092866-46.967158-47.593387-77.13051h-302.67724c-21.918007 30.476467-38.617441 37.364983-48.219615 78.696082h1.043714v71.598823a116.582923 116.582923 0 0 0-1.043714 14.820748l-0.417486 552.020663a118.357238 118.357238 0 0 0 117.209152 117.417895H493.677016l0.939343-756.066872v-1.669943z" fill="#5DA1D3" p-id="10631"></path><path d="M514.551308 236.934804c-10.437146-37.051869-36.738755-89.759457-78.800454-92.681858-46.340929-3.026772-93.934316 0-140.379616 0s-92.264373-2.191801-138.083445 0-70.450737 55.212503-81.618483 93.934316a20.874292 20.874292 0 0 0 20.352435 26.823466h1.043715l-20.874293-20.874293c0 144.763218-1.356829 289.526436-1.4612 434.394025 0 67.11085-2.713658 134.952301 0 202.063151 3.444258 94.560545 75.773681 140.797102 163.132595 140.901474h256.336311a21.500521 21.500521 0 0 0 20.874293-20.874293q0-378.868407 0.939343-757.736814a21.500521 21.500521 0 0 0-20.874293-20.874293c-27.240952 0-27.345323 42.374814 0 42.374814l-20.874292-20.874293q0 378.868407-0.834972 757.736815l20.874293-20.874292H284.620977c-23.692322 0-47.80213 1.356829-71.494451 0-61.057305-3.757373-93.934316-48.950216-96.021746-106.772006-5.114202-154.052278 0-309.043899 0.521858-463.200549 0-55.108132 1.148086-110.111893 1.252457-165.115653a21.500521 21.500521 0 0 0-20.874292-20.874292H96.021745l20.874293 26.823466c8.662831-30.267724 27.345323-49.367702 46.027814-73.686253l-18.265006 10.437146h302.677241l-18.265006-10.437146c18.056263 23.58795 36.738755 42.687928 45.401586 72.016309 6.992888 24.631665 47.906501 13.56829 40.078641-12.628947z" fill="#49494A" p-id="10632"></path><path d="M375.737264 282.33639h32.668267a20.874292 20.874292 0 0 0 0-42.270442H375.737264a20.874292 20.874292 0 0 0-20.874293 20.874293 21.500521 21.500521 0 0 0 20.874293 20.874292zM182.441316 281.814533h124.619526c26.927837 0 26.927837-41.748585 0-41.748585H182.441316c-27.240952 0-27.240952 42.374814 0 42.374814zM283.890377 918.480452H407.048702c27.240952 0 27.240952-41.748585 0-42.374814H283.890377c-27.240952 0-27.240952 41.748585 0 42.374814zM181.710716 917.854223h41.748584c27.240952 0 27.345323-41.748585 0-42.374814h-41.748584c-27.240952 0-27.240952 41.748585 0 41.748585z" fill="#49494A" p-id="10633"></path><path d="M221.319685 165.106364l0.093935-64.501564 148.311847 0.208743-0.093934 64.501564z" fill="#F3D24F" p-id="10634"></path><path d="M369.579347 144.252946H221.2675l20.874292 20.874292V100.625675l-20.874292 20.874292h148.207476l-20.874293-20.874292v64.501563c0 27.240952 41.748585 27.345323 42.374814 0V100.834418a21.500521 21.500521 0 0 0-20.874292-20.874293h-148.207477a21.500521 21.500521 0 0 0-20.874292 20.874293v64.605935a21.500521 21.500521 0 0 0 20.874292 20.874292h148.311848c26.40598 0.313114 26.40598-42.061699-0.626229-42.061699zM0 350.073469V656.508082c0 27.240952 42.270442 27.240952 42.374814 0V350.073469c0-27.240952-41.748585-27.240952-42.374814 0zM20.874292 744.388853c27.240952 0 27.345323-42.374814 0-42.374814s-27.240952 42.374814 0 42.374814z" fill="#49494A" p-id="10635"></path></svg>
              </div>
            </el-col>
            <el-col :span="2">
              <div class="headButton" @click="toAi">
                智能
                <svg style="margin-left: 8px" t="1702215264230" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="1568" width="40" height="40">
                  <path
                    d="M864 595.2V435.2l-89.6-74.88V256L609.28 142.72 505.6 213.12V812.8l81.92 65.92L774.4 761.6v-96z"
                    fill="#FEDDC5" p-id="1569"></path>
                  <path
                    d="M586.88 894.72L492.8 819.2V206.72l116.48-79.36 177.92 121.6v105.6l89.6 74.88V601.6l-89.6 70.4v96.64l-200.32 126.08zM518.4 806.4l70.4 56.32 172.8-108.8V659.2l89.6-70.4V440.96l-89.6-74.88V263.04L609.28 158.72 518.4 220.16V806.4z"
                    fill="#708DB7" p-id="1570"></path>
                  <path
                    d="M678.4 313.6c-7.04 0-12.8-5.76-12.8-12.8V198.4c0-7.04 5.76-12.8 12.8-12.8s12.8 5.76 12.8 12.8v102.4c0 7.04-5.76 12.8-12.8 12.8zM588.8 672c-7.04 0-12.8-5.76-12.8-12.8V569.6l83.2-57.6V424.96l-83.2-53.12V256c0-7.04 5.76-12.8 12.8-12.8s12.8 5.76 12.8 12.8v101.76l83.2 53.12V524.8l-83.2 57.6v76.8c0 7.04-5.76 12.8-12.8 12.8z"
                    fill="#708DB7" p-id="1571"></path>
                  <path
                    d="M679.04 430.08c-4.48 0-8.32-1.92-10.88-5.76-3.84-5.76-1.92-14.08 3.84-17.92l88.32-56.96c5.76-3.84 14.08-1.92 17.92 3.84 3.84 5.76 1.92 14.08-3.84 17.92l-88.32 56.96c-1.92 1.28-4.48 1.92-7.04 1.92zM744.96 584.32c-2.56 0-5.12-0.64-7.68-2.56l-65.92-49.92c-5.76-4.48-7.04-12.16-2.56-17.92 4.48-5.76 12.16-7.04 17.92-2.56l65.92 49.92c5.76 4.48 7.04 12.16 2.56 17.92-2.56 3.84-6.4 5.12-10.24 5.12zM768 672c-1.92 0-4.48-0.64-6.4-1.92l-87.04-48.64c-6.4-3.2-8.32-11.52-5.12-17.28 3.2-6.4 11.52-8.32 17.28-5.12l87.04 48.64c6.4 3.2 8.32 11.52 5.12 17.28-2.56 4.48-6.4 7.04-10.88 7.04zM672.64 739.84c-2.56 0-4.48-0.64-6.4-1.92L500.48 636.8c-5.76-3.84-7.68-11.52-4.48-17.28 3.84-5.76 11.52-7.68 17.92-4.48l165.76 101.12c5.76 3.84 7.68 11.52 4.48 17.28-2.56 3.84-7.04 6.4-11.52 6.4zM662.4 833.92c-1.92 0-3.84-0.64-5.76-1.28l-96-50.56c-6.4-3.2-8.96-10.88-5.12-17.28 3.2-6.4 10.88-8.96 17.28-5.12l96 50.56c6.4 3.2 8.96 10.88 5.12 17.28-1.92 3.84-6.4 6.4-11.52 6.4zM855.04 538.24c-2.56 0-5.12-0.64-7.04-1.92L761.6 477.44c-5.76-3.84-7.68-12.16-3.2-17.92 3.84-5.76 12.16-7.68 17.92-3.2l86.4 58.88c5.76 3.84 7.68 12.16 3.2 17.92-2.56 3.2-6.4 5.12-10.88 5.12z"
                    fill="#708DB7" p-id="1572"></path>
                  <path
                    d="M496.64 262.4h-38.4l-58.88-77.44-67.84 33.92 19.2 96-40.32 40.96-103.04-16-26.88 64.64L256 469.76V531.2l-75.52 62.72 24.32 59.52 94.72-13.44 49.92 54.4-8.32 93.44 56.32 19.2 62.72-76.16 45.44 5.76V262.4z"
                    fill="#E5E4FE" p-id="1573"></path>
                  <path
                    d="M401.92 822.4l-74.88-25.6 9.6-97.92-41.6-45.44-97.92 14.08-31.36-78.08 77.44-64v-49.92L165.76 408.32l33.92-82.56 106.88 16.64 30.72-31.36-19.84-99.2L403.2 168.32 464.64 249.6H518.4v501.76l-53.12-6.4-63.36 77.44z m-47.36-43.52l39.04 12.8 61.44-74.88 38.4 4.48V275.2h-40.96l-56.32-74.24-50.56 24.96 18.56 92.8-49.28 50.56-99.84-15.36-19.2 46.72L268.8 464V537.6l-72.96 60.16 16.64 42.24 91.52-13.44 58.88 63.36-8.32 88.96z"
                    fill="#708DB7" p-id="1574"></path>
                  <path d="M498.56 499.2m-70.4 0a70.4 70.4 0 1 0 140.8 0 70.4 70.4 0 1 0-140.8 0Z" fill="#F8F8FF"
                    p-id="1575"></path>
                  <path
                    d="M498.56 582.4c-46.08 0-83.2-37.12-83.2-83.2s37.12-83.2 83.2-83.2 83.2 37.12 83.2 83.2-37.76 83.2-83.2 83.2z m0-140.8c-32 0-57.6 25.6-57.6 57.6s25.6 57.6 57.6 57.6 57.6-25.6 57.6-57.6-26.24-57.6-57.6-57.6z"
                    fill="#708DB7" p-id="1576"></path>
                </svg>
              </div>
            </el-col>
            <el-col :span="2">
              <div class="headButton" @click="toPaper">
                留言板
                <svg style="margin-left: 10px" t="1702215289586" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="1723" width="32" height="32">
                  <path
                    d="M696.3 854.6c16.2 14.2 41.6 2.7 41.6-18.9V715.3h125.5c41.6 0 75.3-33.7 75.3-75.3V355.1H374c-41.6 0-75.3 33.7-75.3 75.3v284.9h238.4l159.2 139.3z"
                    fill="#F4C708" p-id="1724"></path>
                  <path
                    d="M712.6 882.2c-11 0-21.7-3.9-30.4-11.6l-153.1-134H160.6c-53.3 0-96.6-43.4-96.6-96.6V238.4c0-53.3 43.4-96.6 96.6-96.6h702.8c53.3 0 96.6 43.4 96.6 96.6V640c0 53.3-43.4 96.6-96.6 96.6H759.2v99c0 18.5-10.4 34.6-27.3 42.3-6.2 2.9-12.8 4.3-19.3 4.3z m-552-697.7c-29.8 0-54 24.2-54 54V640c0 29.8 24.2 54 54 54h376.5c5.2 0 10.2 1.9 14 5.3l159.2 139.3c0.5 0.4 1.8 1.7 4 0.6 2.2-1 2.2-2.8 2.2-3.4V715.3c0-11.8 9.5-21.3 21.3-21.3h125.5c29.8 0 54-24.2 54-54V238.4c0-29.8-24.2-54-54-54H160.6z"
                    fill="#111111" p-id="1725"></path>
                  <path d="M499.5 426.7m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#111111" p-id="1726"></path>
                  <path d="M742.9 426.7m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#111111" p-id="1727"></path>
                  <path d="M277.3 426.7m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#111111" p-id="1728"></path>
                </svg>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </el-header>
  </div>
</template>

<script>
export default {
  name: "myHeader",
  methods: {
    toHome() {
      this.$router.push("/home");
    },
    toDaily() {
      this.$router.push("/Daily");
    },
    toWeb() {
      this.$router.push("/Photo");
    },
    toPaper() {
      this.$router.push("/Paper");
    },
    toAi() {
      this.$router.push("/ai");
    },
    toMy2023() {
      window.location.href = 'https://www.1ys53p.top/1735455616995.html';
    }
  },
};
</script>

<style scoped>
@font-face {
  font-family: "阿里妈妈灵动体 VF Thin";
  src: url("https://www.1ys53p.top/1719369555793.woff2") format("woff2");
  font-display: swap;
}

@font-face {
  font-family: "old";
  src: url('https://www.1ys53p.top/1719369422391.woff2') format("woff2");
  font-display: swap;
}

.headButton {
  font-family: '阿里妈妈灵动体 VF Thin';
  font-weight: bolder;
  font-size: large;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
}

.headButton:hover {
  background-color: #77e79c;
  cursor: pointer;
}

.myLogo {
  height: 50px;
  width: 50px;
  border-radius: 20%;
  background-image: url("../../assets/微信图片_20230206145629.jpg");
  background-size: cover;
}

.myLogoText {
  background: linear-gradient(45deg, #002fa7, #22c358);
  -webkit-background-clip: text;
  /* 适用于WebKit内核的浏览器（Chrome、Safari等） */
  color: transparent;
  /* 让文字透明 */
}

.container {
  font-size: 18px;
  color: #333;
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.hover-me {
  position: relative;
  z-index: 1;
  text-decoration: underline;
  text-underline-offset: 4px;
  text-decoration-color: #333;
}

.tooltip {
  width: 100%;
  height: 10px;
  background: #ffffff;
  padding: 0.25em;
  text-align: center;
  position: absolute;
  top: 40px;
  left: 0;
  opacity: 0;
  visibility: hidden;
  transform-origin: center top;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  transition: opacity 0.3s ease-in-out;
}

.tooltip::before {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 80%;
  transform: translateX(-50%);
  border-width: 8px 7px 0;
  border-style: solid;
  border-color: #ffffff transparent transparent transparent;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
}

.tooltip p {
  margin: 0;
  color: #333;
  font-weight: 600;
}

.container:hover .tooltip {
  top: -10px;
  opacity: 1;
  visibility: visible;
  animation: goPopup 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55) forwards;
}

.container:hover .tooltip p {
  animation: bounce 2s ease-in-out infinite;
}

@keyframes goPopup {
  0% {
    transform: translateY(0) scaleY(0);
    opacity: 0;
  }

  50% {
    transform: translateY(-50%) scaleY(1.2);
    opacity: 1;
  }

  100% {
    transform: translateY(-100%) scaleY(1);
    border-radius: 8px;
    opacity: 1;
    height: 40px;
  }
}

@keyframes bounce {

  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-3px);
  }

  60% {
    transform: translateY(-2px);
  }
}
</style>